import { SetStateAction } from "jotai";
import { Dispatch } from "react";

import ViewRecordDrawer from "../../../Drawers/Records/ViewRecordDrawer";
import { callFunctionIfExists } from "../../../../utils/GeneralUtils";
import useViewRecordURL from "../../../../hooks/useViewRecordURL";
import { View } from "../../../../types/PageInterfaces";
import useModule from "../../../../hooks/useModule";
import { DetailView } from "./SharedToolbar";

interface Props {
  openRecordData: DetailView;
  setOpenRecordData: Dispatch<SetStateAction<DetailView>>;
  open?: boolean;
  view: View;
  onClose?: () => void;
  toggleTransformIssueDrawer?: (record: any) => void;
}

const SharedViewRecordDrawer = ({
  openRecordData,
  setOpenRecordData,
  open,
  view,
  onClose,
  toggleTransformIssueDrawer,
}: Props) => {
  const { module: viewRecordModule } = useModule(openRecordData?.moduleAPIName);
  useViewRecordURL({
    setOpenRecordData,
    viewID: view?.id,
  });

  return (
    <>
      <ViewRecordDrawer
        open={open ?? !!openRecordData}
        module={viewRecordModule!}
        // @ts-ignore
        recordID={openRecordData?.recordID}
        onClose={() => {
          setOpenRecordData(null);
          callFunctionIfExists(onClose);
        }}
        // @ts-ignore
        tab={openRecordData?.tab}
        defaultRecordLayout={view?.DefaultRecordLayout}
        view={view}
        toggleTransformIssueDrawer={toggleTransformIssueDrawer}
      />
    </>
  );
};

export default SharedViewRecordDrawer;
